// 测评医生端测试环境
const GLOBAL_API_ROOT = 'https://szr-test.medkg.cn/'; // 后端请求地址
//const GLOBAL_API_ROOT = '/'; // 后端请求地址
const GLOBAL_SYSTEM = ''; 
const GLOBAL_SETTING = { // 项目特殊配置
}
const ID = ""; // 用来获取项目信息，如果不需要通过请求获取，则此字段不要填，填下面SYSTEM_MSG字段
const SYSTEM_MSG = {
    name: '全自动数字人体质辨识仪', // 项目名称
    logo: '/common/szr.jpg',
    favicon_url: '/common/szr.ico'
}

// 以下是打包桌面端需要用到的
// electron-builder.yml
const APP_ID = 'com.szr.www'; // 应用的唯一id,确认后不要改动了！不然在更新时候，会被认做为两个应用。这个是在apple那里你申请证书的时候，用生成的那个id就可以，类似这种'com.example.app'
const COPYRIGHT = 'szr'; // 版权信息
// 以下图标从请求获取
const LOGO = './public/common/szr.ico' // logo路径,格式为.ico，大小需要256*256的，否则打包会报错

// package.json
const VERSION = '1.0.0'; //版本号
const PACKAGE_NAME = 'szr'; //包名
module.exports = {
    GLOBAL_API_ROOT,
    GLOBAL_SYSTEM,
    ID,
    SYSTEM_MSG,
    APP_ID,
    COPYRIGHT,
    VERSION,
    PACKAGE_NAME,
    LOGO,
    GLOBAL_SETTING
}
